import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/clinics/src/app/home/HomeClient.tsx");
